// StripeWrapper.js
import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_live_51QdE88AkSaHqioapBp7nscAVaxE1oc2EpNbYMkYrmxGcZyBrDZTgROwuCEQu2wvgBYSdbfCelDSDVFFnZkbPbdaT00o5rFgKuw',{
  locale: 'de', // Sets the language to German
}); // Your Stripe Publishable Key

const StripeWrapper = ({ children }) => (
  <Elements stripe={stripePromise}>{children}</Elements>
);

export default StripeWrapper;
